import { CorePriority, CorePriorityGoal } from '../types/corePriority';

export const DEFAULT_CORE_PRIORITY_GOALS: Array<Pick<CorePriorityGoal, 'goal' | 'description'>> = [
  {
    goal: 'Customer Delivery',
    description:
      'Demonstrates a strong commitment to understanding and meeting the needs of internal and external customers. Builds positive working relationships, proactively addresses concerns, and delivers high-quality service that enhances overall customer satisfaction and trust.'
  },
  {
    goal: 'Problem Resolution & Decision Making',
    description:
      'Applies critical thinking and analytical skills to independently identify issues, evaluate options, and implement effective solutions. Takes initiative in addressing challenges and presents well-reasoned recommendations that support business objectives.'
  },
  {
    goal: 'Process Improvement & Efficiency',
    description:
      'Analyzes existing workflows to identify inefficiencies and opportunities for improvement. Actively contributes to streamlining processes, improving quality, and increasing operational efficiency through well-defined and sustainable solutions.'
  },
  {
    goal: 'Learning & Continuous Development',
    description:
      'Demonstrates a strong commitment to ongoing personal and professional development by actively acquiring new skills and knowledge relevant to the role. Stays current with industry trends, applies learning to improve job performance, and shares knowledge to support team growth and effectiveness.'
  }
];

export const createDefaultGoals = (): CorePriorityGoal[] =>
  DEFAULT_CORE_PRIORITY_GOALS.map((template) => ({
    goal: template.goal,
    description: template.description,
    category: '',
    weightage: undefined
  }));

export const normalizeGoals = (corePriority: CorePriority | null): CorePriorityGoal[] => {
  if (corePriority?.goals && corePriority.goals.length > 0) {
    return corePriority.goals.map((goal) => ({
      goal: goal.goal || '',
      description: goal.description || '',
      category: goal.category || '',
      weightage: goal.weightage
    }));
  }

  if (corePriority?.priorities?.trim()) {
    return [
      {
        goal: 'Core Priority',
        description: corePriority.priorities.trim(),
        category: '',
        weightage: undefined
      }
    ];
  }

  return [];
};

export const getGoalValidationError = (goals: CorePriorityGoal[]): string | null => {
  if (goals.length === 0) {
    return 'Please add at least one goal';
  }

  for (let index = 0; index < goals.length; index += 1) {
    const goal = goals[index];
    const item = index + 1;

    if (!goal.goal?.trim()) {
      return `Goal title is required for item ${item}`;
    }

    if (!goal.description?.trim()) {
      return `Description is required for item ${item}`;
    }

    if (!goal.category?.trim()) {
      return `Category is required for item ${item}`;
    }

    if (!goal.weightage || goal.weightage <= 0) {
      return `Weightage must be greater than 0 for item ${item}`;
    }
  }

  return null;
};
